import { NgModule, ENVIRONMENT_INITIALIZER, APP_ID, makeStateKey, TransferState } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CookieService } from 'ng2-cookies';
import {
  HttpService,
  HttpConfigService,
} from '@citi-gcg-173875/citi-http';
import {
  AppConfigService,
  SessionService,
  StorageService,
  WINDOW_PROVIDER,
  AppConfig,
  IS_SSRENDERED_APP,
  NAVIGATOR_PROVIDER,
} from '@citi-gcg-173875/citi-utils';
import { provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage } from 'ngx-webstorage';
import { APP_BASE_HREF } from '@angular/common';
import { NgaLoginServiceModule } from '@citi-gcg-173875/nga-login-service-shared';
import { CitiSecurityModule } from '@citi-gcg-173875/citi-security';
import { SiteCatalystService } from '@citi-gcg-173875/citi-analytics';
import { CoreModule } from './core/core.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { CbolCoreModule } from '@citi-gcg-173875/cbol-core';
import { MfaUiModule } from '@citi-gcg-173875/citi-mfa-ui';
import { CitibankRoutingModule } from './citibank-routing.module';
import { Layouts } from '@citi-gcg-173875/citi-branding';
import { MktContentService, MktContentStaticService, MktContentStorageService, MktEnvironmentService } from './core/services';

const envVars = makeStateKey<any>('envVars');
const IS_DEV_MODE = makeStateKey<boolean>('isInternal');
export function appConfigLoad(appConfigService: AppConfigService, transferState: TransferState) {
  const nodeEnv = transferState.get(envVars, {});
  const env: any = { ...environment, ...nodeEnv };
  const defaultHeaders = {
    'Content-Type': 'application/json',
    'client_id': env.CBOL_CLIENT_ID,
    'businessCode': 'GCB',
    'countryCode': 'US',
    'channelId': 'CBOL',
    'Accept': 'application/json',
  };

  appConfigService.setAppConfig(<AppConfig>{
    ...env,
    httpService: {
      ...env.httpService,
      defaultHeaders
    },
    contentService: {
      staticBaseUrl: env.apiServerUrlPlatformClient,
      defaultHeaders
    },
    customConfig: {
      ...env.customConfig,
      brandingApiUrl: env.CBOL_SSR_URL,
      brandingEndpoint: `${env.CBOL_SSR_URL}${env.customConfig.brandingEndpoint}`
    },
    sessionService: {
      ...env.sessionService,
      sessionKeepAliveUrl: env.apiServerUrlPlatformClient + '/public/sso/keepalive',
      sessionTimeoutUrl: env.CBOL_SSR_URL + '/US/ag/sign-off?sessionTimeout=true'
    },
    aemConfig: {
      ...env.aemConfig,
      aemServerUrl: env.aemServerUrl || env.aemConfig.aemServerUrl,
      aemStaticAssetsUrl: env.aemStaticAssetsUrl || env.aemConfig.aemStaticAssetsUrl,
      aemContentServiceUrl: env?.aemContentServiceUrl || env.aemConfig.aemContentServiceUrl,
      aemContentServiceHeaders: {}
    },
    apiServerUrl: env.apiServerUrlPlatformClient
  });

  return (): Promise<boolean> => {
    return new Promise((resolve) => {
      resolve(true);
    });
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreModule,
    CitibankRoutingModule,
    BrowserModule,
    NgaLoginServiceModule,
    CitiSecurityModule,
    Layouts.forRoot(),
    CbolCoreModule.forRoot(),
    MfaUiModule.forRoot()
  ],
  providers: [
    {
      provide: ENVIRONMENT_INITIALIZER,
      useFactory: appConfigLoad,
      deps: [AppConfigService, TransferState],
      multi: true,
    },
    {
      provide: IS_SSRENDERED_APP,
      useValue: true
    },
    { provide: APP_BASE_HREF, useValue: '/credit-cards/' },
    provideNgxWebstorage(withNgxWebstorageConfig({
      prefix: '',
      separator: '',
      caseSensitive: true
    }),
      withLocalStorage(),
      withSessionStorage()
    ),
    MktContentService,
    MktContentStaticService,
    MktContentStorageService,
    MktEnvironmentService,
    HttpService,
    HttpConfigService,
    StorageService,
    CookieService,
    SessionService,
    SiteCatalystService,
    { provide: APP_ID, useValue: 'citi-universal' },
    WINDOW_PROVIDER,
    NAVIGATOR_PROVIDER,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    private _transferState: TransferState,
    private _cookieService: CookieService,
    private _appConfigService: AppConfigService,
    private _mktEnvironmentService:MktEnvironmentService
  ) {
    const environment = this._mktEnvironmentService.getEnvironmentVar('environment');
    const isDevMode = (this._cookieService.get('X-AKAMAI-BV') === 'true' || environment !== 'PROD');
    this._transferState.set(IS_DEV_MODE, isDevMode);
    if (this._appConfigService.getEnvironment() == 'PROD') {
      console.log = function () {
        return false;
      };
    }
  }
}